"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const EfficientCursor_module_css_1 = __importDefault(require("./EfficientCursor.module.css"));
const Cursor_1 = __importDefault(require("./Cursor"));
const EfficientCursor = (_a) => {
    var { children, speed = 0.1 } = _a, props = __rest(_a, ["children", "speed"]);
    const cursorRef = react_1.useRef(document.createElement('div'));
    const handleMount = () => {
        const cursor = new Cursor_1.default(cursorRef.current, speed);
        return () => {
            cursor.destroy();
        };
    };
    react_1.useEffect(handleMount, []);
    return (jsx_runtime_1.jsx("div", Object.assign({ ref: cursorRef, className: EfficientCursor_module_css_1.default.container }, props, { children: children }), void 0));
};
exports.default = EfficientCursor;
//# sourceMappingURL=EfficientCursor.js.map